import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { CREATE_LABEL, SAVE_CHANGES_LABEL, CREATE_SUCCESS, UPDATE_SUCCESS, CREATE_FAILED, UPDATE_FAILED } from '@microsec/constants';
import { FormBuilderComponent } from '@microsec/components';
import { BaseComponent } from '@ids-components';
import { FormItem } from '@microsec/models';
import { OrganizationService } from '@microsec/services';

import { Observable } from 'rxjs';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

const FORM_PARAMS = {
  NAME: 'name',
  ADDRESS: 'address',
  TELEPHONE_NUMBER: 'telephone_number',
};

@Component({
  selector: 'app-shared-organization-form',
  templateUrl: './shared-organization-form.component.html',
  styleUrls: ['./shared-organization-form.component.scss'],
  imports: [FormBuilderComponent],
})
export class SharedOrganizationFormComponent extends BaseComponent implements AfterViewInit {
  organization: any = null;

  fields: FormItem[] = [];

  @ViewChild('fb') form!: FormBuilderComponent;

  CREATE_LABEL = CREATE_LABEL;

  SAVE_CHANGES_LABEL = SAVE_CHANGES_LABEL;

  constructor(
    private dialogConfig: DynamicDialogConfig,
    private organizationSrv: OrganizationService,
  ) {
    super();
  }

  async ngAfterViewInit() {
    await this.prepareConfigs();
    this.organization = this.dialogConfig?.data?.organization;
    this.initForm();
  }

  initForm() {
    const fields: FormItem[] = [
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.NAME,
        label: 'Name',
        field: 'input',
        required: true,
        fieldInfo: 'Name of organization',
        defaultValue: '',
        focused: true,
      } as FormItem),
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.ADDRESS,
        label: 'Address',
        field: 'input',
        fieldInfo:
          "Address of the organization. Enter a valid address using letters, numbers, spaces, and common symbols like the following: & / . ( ) , ' + @ # : ; - ",
        defaultValue: '',
      } as FormItem),
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.TELEPHONE_NUMBER,
        label: 'Phone number',
        field: 'input',
        fieldInfo: 'Phone number of the organization. Enter a valid phone number with the country code, e.g. +65 66667777',
        defaultValue: '',
      } as FormItem),
    ];
    fields.forEach((field) => (field.isMediumSize = true));
    this.fields = fields;
    if (!!this.organization) {
      this.form.patchValue(this.organization);
      this.form.disableControl(FORM_PARAMS.NAME);
    }
  }

  onSubmit(closeDialog: () => void) {
    const payload = this.getPayload();
    const request: Observable<any> = !this.organization?.id
      ? this.organizationSrv.createOrganization(payload)
      : this.organizationSrv.updateOrganization(this.organization.id, payload);
    request.subscribe({
      next: () => {
        const message = !this.organization ? CREATE_SUCCESS : UPDATE_SUCCESS;
        this.showSuccessMessage(message.replace('{0}', 'organization'));
        closeDialog();
      },
      error: (err: any) => {
        this.form.showServerErrorMessage({
          error: {
            errors: ((err.error?.detail as any[]) || []).reduce((object, p) => {
              object[p.loc?.[1]] = p.msg;
              return object;
            }, {}),
          },
        });
        const message = !this.organization ? CREATE_FAILED : UPDATE_FAILED;
        this.showErrorMessage(message.replace('{0}', 'organization'));
      },
    });
  }

  getPayload() {
    const payload = { ...this.form.getRawValue() };
    payload.group_type = 'organization';
    payload.keycloak_name = payload.name;
    if (!payload[FORM_PARAMS.ADDRESS]) {
      delete payload[FORM_PARAMS.ADDRESS];
    }
    if (!payload[FORM_PARAMS.TELEPHONE_NUMBER]) {
      delete payload[FORM_PARAMS.TELEPHONE_NUMBER];
    }
    return payload;
  }
}
